import { Link } from "react-router-dom";
import { useParams } from "react-router-dom"

export const Product = ({products, cartTotals, setCartTotals, setCartContents, cartContents}) => {

    const params = useParams();
    

    const getProduct = products.find( (product) => product.id === Number(params.id)  );
    console.log(getProduct);

    const handleAddToCart = (id) => {
      
        const product = products.find( (product) => product.id === id  );
        
        setCartTotals(Number(cartTotals) + Number(product.price));

        const addProduct = {
            id: new Date().getTime().toString(),    
            name: product.name,
            price: product.price,
            img: product.img    
        }
    
        setCartContents([...cartContents, addProduct]);

        let getAddToCart = document.getElementById(id);

        getAddToCart.textContent = 'Adding to cart...';

        setTimeout( ()=> {
            getAddToCart.textContent = 'Add to cart';
        }, 500 )
      }

  return (
    <>
     <div className="p-6 bg-slate-300"></div>
    <div className='flex justify-center bg-black items-center mt-100 h-48 mb-10'>
        <h1 className='text-white'>Viewing a {getProduct.name}</h1>
    </div>


    <section className="p-10">

    <div className="flex justify-center items-center  md:justify-start md:items-start flex-col md:flex-row" >

    <div className="flex-1">
      <img src={getProduct.img} alt={getProduct.name} width="80%" />  
    </div>
    <div className="flex-1 p-4 bg-slate-50">
      
      <div className="flex  flex-col items-center md:items-start">
      
      <h1 className="text-4xl text-blue-400 my-4">{getProduct.name}</h1>
      <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iste, eos quaerat, repellendus praesentium tempore debitis quo dolores mollitia sapiente nemo tempora. Minima, quis aperiam doloribus earum veniam, accusantium, similique culpa dignissimos velit repudiandae id. Omnis qui, modi deleniti aperiam, quis harum deserunt sequi nulla earum mollitia architecto nobis quisquam enim praesentium autem id placeat, alias minus eaque eveniet maxime pariatur! Dignissimos, rerum laudantium unde ut repudiandae exercitationem, quaerat assumenda vitae odit voluptate at ad et deleniti voluptates magnam explicabo repellendus ipsa ab amet, a officia eveniet. Obcaecati incidunt eos error iste hic enim laboriosam itaque cumque temporibus nulla in nostrum, porro molestias nihil nisi ducimus non praesentium expedita reprehenderit accusamus. Eaque sit assumenda libero in, ducimus magnam inventore! Debitis tenetur quis ipsum dolorum nostrum ea nulla voluptatibus eaque, sapiente omnis voluptas vero. Repudiandae doloribus optio id voluptatum ab, molestiae reiciendis at voluptas dolorum facilis amet neque iste ipsa omnis corrupti sit rerum harum modi minus accusamus illum animi eius? Provident suscipit enim cum aperiam tempora nobis explicabo deserunt ut facere adipisci, obcaecati quasi magnam optio fugit ullam hic, nam totam repudiandae vero officia reprehenderit unde magni. Architecto iste omnis tempore expedita repudiandae fuga magnam distinctio labore inventore doloribus dolorem tenetur atque at, saepe commodi hic magni quo soluta re!</p>
      <h2 className="text-3xl my-4">Price : €{getProduct.price}</h2>

      <button id={getProduct.id} onClick={()=> handleAddToCart(getProduct.id)} className="w-full px-4 py-2 my-2 rounded-lg bg-red-500 text-white" >Add To Cart</button>

      <p className="text-blue-800 font-bold">
        <Link to="/products">Go Back</Link>
      </p>
    </div>
    </div>


    </div>

    </section>

    </>
  )
}
